module.exports = __webpack_public_path__ + "static/media/iqm-logo.70881ee0.png";